import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Container, Row, Col, Tabs, Tab } from "react-bootstrap";

import ClassGrades from "./ClassGrades";
import StudentsForClass from "./StudentsForClass";
import ModalAddStudents from "./modals/ModalAddStudents";
import ClassAttendance from "./ClassAttendance";

const ClassStudents = (props) => {
  const [t] = useTranslation(["class", "global"]);

  const [studentsCount, setStudentsCount] = useState(0);
  const [showModalAddStudents, setShowModalAddStudents] = useState(false);
  const [newStudentsAdd, setNewStudentsAdd] = useState([]);
  const [refreshStudentList, setRefreshStudentList] = useState(false);
  const [defaultTab, setDefaultTab] = useState("scores");

  const addStudent = (students) => {
    const updatedStudentList = props.studentsInClass.concat(students);
    setStudentsCount(updatedStudentList.length);
    props.classId === "new"
      ? props.setFieldStudents(updatedStudentList)
      : props.setCurrentStudents(updatedStudentList);
    setNewStudentsAdd(students);
  };

  return (
    <Container>
      <Row>
        <Col md={6} className="mb-2">
          <h5>
            <b>{t("class:stundentsClass.title")}</b>
          </h5>
        </Col>
        <Col md={6} className="mb-2 text-end">
          {t("class:stundentsClass.totalStudents")}
          {studentsCount}
        </Col>
      </Row>
      {props.classId === "new" || props.changeSchooling ? (
        <StudentsForClass
          setFieldStudents={props.setFieldStudents}
          schoolingFilters={props.schoolingFilters}
          setShowModalAddStudents={setShowModalAddStudents}
          newStudentsAdd={newStudentsAdd}
          setNewStudentsAdd={setNewStudentsAdd}
          setStudentsCount={setStudentsCount}
        />
      ) : (
        <Row>
          <Col xs={12}>
            <Tabs
              defaultActiveKey={defaultTab}
              id="classStudentsTabs"
              onSelect={(k) => setDefaultTab(k)}
            >
              <Tab eventKey="scores" title={t("class:main.scores")}>
                <ClassGrades
                  classId={props.classId}
                  setShowModalAddStudents={setShowModalAddStudents}
                  setFieldStudents={props.setFieldStudents} // TODO: Verificar que esto sea compatible con el formato actual
                  setStudentsCount={setStudentsCount}
                  refreshStudentList={refreshStudentList}
                  setRefreshStudentList={setRefreshStudentList}
                  setCurrentStudents={props.setCurrentStudents}
                  classInfo={props.classInfo}
                />
              </Tab>
              <Tab eventKey="attendance" title={t("class:main.attendance")}>
                {defaultTab === "attendance" && (
                  <ClassAttendance
                    classId={props.classId}
                    setShowModalAddStudents={setShowModalAddStudents}
                    setFieldStudents={props.setFieldStudents}
                    setStudentsCount={setStudentsCount}
                    refreshStudentList={refreshStudentList}
                    setRefreshStudentList={setRefreshStudentList}
                    schoolCycleId={props.schoolCycleId}
                    setCurrentStudents={props.setCurrentStudents}
                  />
                )}
              </Tab>
            </Tabs>
          </Col>
        </Row>
      )}
      {showModalAddStudents && (
        <ModalAddStudents
          classId={props.classId}
          showModalAddStudents={showModalAddStudents}
          setShowModalAddStudents={setShowModalAddStudents}
          filters={props.schoolingFilters}
          classStudents={props.studentsInClass}
          addStudents={addStudent}
          setRefreshStudentList={setRefreshStudentList}
        />
      )}
    </Container>
  );
};

export default ClassStudents;

ClassStudents.propTypes = {
  classId: PropTypes.string,
  setFieldStudents: PropTypes.func,
  schoolingFilters: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  studentsInClass: PropTypes.array,
  schoolCycleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  changeSchooling: PropTypes.bool,
  setCurrentStudents: PropTypes.func,
  classInfo: PropTypes.object,
};
